var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBooking(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.926,
    height: 22.63,
    viewBox: "0 0 17.926 22.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pending_Bookings",
    "data-name": "Pending Bookings",
    transform: "translate(-236.449 -194.64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M285.931,196.2v1.711q.323-.019.649-.019c.218,0,.434.007.649.019V196.2h1.725V194.64h-4.749V196.2h1.725Z",
    transform: "translate(-41.168)",
    fill: "#727376"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M237.529,238.413h-1.08a9.006,9.006,0,0,0,8.252,8.252v-1.08a.711.711,0,0,1,1.423,0v1.08a9,9,0,0,0,8.251-8.252H253.3a.711.711,0,0,1,0-1.423h1.079a9,9,0,0,0-8.251-8.252v1.079a.711.711,0,0,1-1.423,0v-1.079a9,9,0,0,0-8.251,8.252h1.08a.711.711,0,0,1,0,1.423Zm7.171-5.52a.711.711,0,0,1,1.423,0v4.1h2.894a.711.711,0,0,1,0,1.423h-3.6a.711.711,0,0,1-.711-.711v-4.809Z",
    transform: "translate(0 -29.394)",
    fill: "#727376"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooking);
export default __webpack_public_path__ + "static/media/booking.44a19e890b1468ed9f4649797f897e1b.svg";
export { ForwardRef as ReactComponent };